/* store para manejar toda la info de un evento */
import { create } from "zustand";
import { api } from "../services/api";

const useEventoStore = create((set, get) => ({
  eventosPorId: {},
  _pending: {},
  TTL: 5 * 60 * 1000,

  fetchEvento: async (id, force = false) => {
    const cached = get().eventosPorId[id];
    if (!force && cached && Date.now() - cached.lastFetch < get().TTL) {
      return cached.data;
    }

    // si ya hay un request en vuelo para este id, reutilizarlo
    if (get()._pending[id]) {
      return get()._pending[id];
    }

    const promise = api.eventos.get(id)
      .then(response => {
        set((s) => {
          const { [id]: _, ...restPending } = s._pending;
          if (response.status === "success") {
            return {
              _pending: restPending,
              eventosPorId: {
                ...s.eventosPorId,
                [id]: { data: response.data, lastFetch: Date.now() },
              },
            };
          }
          return { _pending: restPending };
        });
        return response.status === "success" ? response.data : null;
      })
      .catch(e => {
        set((s) => {
          const { [id]: _, ...restPending } = s._pending;
          return { _pending: restPending };
        });
        console.error("[EVENTO] Error:", e);
        return null;
      });

    set((s) => ({ _pending: { ...s._pending, [id]: promise } }));
    return promise;
  },

  getEvento: (id) => get().eventosPorId[id]?.data ?? null,

  // vuelve a pedir el evento y mantiene el anterior a la vista mientras llega:
  // borrarlo dejaba en blanco las pantallas que lo leen del store (Layout)
  invalidar: (id) => get().fetchEvento(id, true),

  reset: () => set({ eventosPorId: {}, _pending: {} }),
}));

export default useEventoStore;